export default __webpack_public_path__ + "static/feature2-69e6eb40e96b39c8c60db266a9e19496.png";